import React from 'react';

const ModalDeleteChatHistory = ({
  dettagliProgetto,
  CancellaCronologiaChat,
  setIsOpen,
}) => {
  return (
    <div
      className="modal-clear-history-overlay modal-clear-history-show"
      style={{ zIndex: '99999999999999' }}
    >
      <div className="modal-clear-history-modal">
        <div className="modal-clear-history-header">
          <button
            className="modal-clear-history-close-button"
            onClick={(e) => setIsOpen(!e)}
            style={{ color: 'black' }}
          >
            ×
          </button>
        </div>
        <div className="modal-clear-history-body">
          {dettagliProgetto.language === 'en'
            ? 'Do you confirm that you want to clear the current chat history?'
            : "Confermi di voler cancellare l'attuale cronologia della chat?"}
        </div>
        <div className="modal-clear-history-footer">
          <button
            className="modal-clear-history-button modal-clear-history-cancel"
            onClick={(e) => setIsOpen(!e)}
          >
            {dettagliProgetto.language === 'en' ? 'Cancel' : 'Annulla'}
          </button>
          <button
            className="modal-clear-history-button modal-clear-history-confirm"
            onClick={CancellaCronologiaChat}
          >
            {dettagliProgetto.language === 'en' ? 'Confirm' : 'Confermo'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteChatHistory;
